const products = [
  {
    id: 1,
    name: "Masker",
    category: "kesehatan",
    categoryLabel: "Perlengkapan Kesehatan",
    description: "Pilihan masker untuk kebutuhan operasional dan institusi.",
    image: "/images/products/masker.png",
  },
  {
    id: 2,
    name: "Sarung Tangan Nitril",
    category: "kesehatan",
    categoryLabel: "Perlengkapan Kesehatan",
    description: "Pilihan sarung tangan sesuai kebutuhan dan spesifikasi.",
    image: "/images/products/nitrile-gloves.png",
  },
  {
    id: 3,
    name: "Karung",
    category: "kesehatan",
    categoryLabel: "Pengemasan dan Penyimpanan",
    description: "Pilihan karung untuk kebutuhan penyimpanan dan usaha.",
    image: "/images/products/hair-net.png",
  },
  {
    id: 4,
    name: "Lakban Sayur",
    category: "pengemasan",
    categoryLabel: "Pengemasan dan Penyimpanan",
    description: "Lakban sayur fresh untuk kebutuhan pengemasan.",
    image: "/images/products/lakban-sayur.png",
  },
];

export default products;
